/**
 * Stage 33/37 — shared presentational primitives for the cross-unit surface.
 *
 * Stage 37 reduced this file to the one primitive that is still shared by the table and
 * the drawer: the candidate-API error box, which must render the envelope's `errorCode`
 * (flag off, backend off) instead of a silent empty state.
 *
 * The score tiles (`TrackAScoreView` / `AnomalyScoreView` / `PairingStrengthView`), the
 * null-aware `Field` / `NullableValue`, the badge row, the warning and disclaimer lists
 * and the candidate pagination control went with the old candidate card. The analyst card
 * renders the scenarios 1–5 primitives (`components/case-drawer-primitives.tsx`) instead,
 * so scenarios 6–7 cannot grow a second look-alike set of cards.
 */

/** Shown when a candidate query fails — including the flag-off envelope. */
export function CandidateError({ message, code }: { message: string; code?: string | null }) {
  return (
    <div data-block="candidate-error" className="rounded-[4px] border border-[var(--border-default)] bg-[var(--bg-subtle)] px-3 py-4">
      <p className="text-[12px] text-[var(--text-secondary)]">{message}</p>
      {code && <p className="mt-1 font-mono text-[10px] text-[var(--text-tertiary)]">{code}</p>}
    </div>
  )
}
